import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Banner as BannerView } from "@similarweb/ui-components";
import styled from "styled-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { blue } = colorsPalettes;

const Banner = styled(BannerView)`
    background-color: ${blue[100]};
    padding: 20px;
`;
const Title = styled(I18n)`
    ${setFontVariant("subtitle1")}
`;
const TitleContainer = styled(CenteredFlexRow)`
    justify-content: unset;
`;
const Subtitle = styled(I18n)`
    ${setFontVariant("body2")}
`;

export const StyledBanner = { Banner, TitleContainer, Subtitle, Title };
